import * as React from 'react';

import { colors } from '@/globalStyles';

export const IconMatrixAddSeparatorLeft = props => {
  const fill = props?.fill || colors.nero;
  return (
    <svg width="31" height="30" viewBox="0 0 31 30" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        strokeWidth="0"
        clipRule="evenodd"
        d="M21.7571 8.33333H11.2429C10.3592 8.33333 9.64286 9.16907 9.64286 10.2V19.8C9.64286 20.8309 10.3592 21.6667 11.2429 21.6667H21.7571C22.6408 21.6667 23.3571 20.8309 23.3571 19.8V10.2C23.3571 9.16907 22.6408 8.33333 21.7571 8.33333ZM11.2429 7C9.72802 7 8.5 8.43269 8.5 10.2V19.8C8.5 21.5673 9.72802 23 11.2429 23H21.7571C23.272 23 24.5 21.5673 24.5 19.8V10.2C24.5 8.43269 23.272 7 21.7571 7H11.2429Z"
      />
      <path
        fillRule="evenodd"
        strokeWidth="0"
        clipRule="evenodd"
        d="M16.0536 13.4176V14.4105H15.0607C14.7507 14.4105 14.5 14.6612 14.5 14.9712C14.5 15.2812 14.7507 15.5319 15.0607 15.5319H16.0536V16.5248C16.0536 16.8348 16.3043 17.0855 16.6143 17.0855C16.9243 17.0855 17.175 16.8348 17.175 16.5248V15.5319H18.1679C18.4778 15.5319 18.7286 15.2812 18.7286 14.9712C18.7286 14.6612 18.4778 14.4105 18.1679 14.4105H17.175V13.4176C17.175 13.1077 16.9243 12.8569 16.6143 12.8569C16.3043 12.8569 16.0536 13.1077 16.0536 13.4176Z"
      />
      <path d="M6.5 7V23" fill="none" stroke={fill} strokeLinecap="round" />
    </svg>
  );
};

export default IconMatrixAddSeparatorLeft;
